<template>
  <div class="history">
    <div class="title flex-between-center">
      <p>交易历史</p>
      <!-- <i :class="foldFlag?'el-icon-arrow-down':'el-icon-arrow-up'" @click="foldOrUnfold"></i> -->
    </div>
    <div class="table" :id="foldFlag ? 'table-fold' : 'table-unfold'">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="userName" align="left" label="用户">
        </el-table-column>
        <el-table-column prop="eventType" align="left" label="事件">
          <template #default="scope">
            <span>
              {{ recordTypeChange(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="price" align="left" label="价格(¥)">
          <template #default="scope">
            <span>
              {{ scope.row.price || '——' }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="owner" label="藏家">
          <template #default="scope">
            <span>
              {{ scope.row.nftVO.ownerId }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          align="left"
          label="时间"
          width="200"
        >
          <template #default="scope">
            <span>
              {{ timeChange(scope.row.createTime) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-phone">
        <div
          v-for="(v, k) in tableData"
          :key="k"
          class="item flex-between-center"
        >
          <div class="left">
            <p class="name">{{ v.userName }}</p>
            <p class="time">{{ timeChange(v.createTime) }}</p>
          </div>
          <div class="right">
            <p class="type">{{ recordTypeChange(v) }}</p>
            <p v-if="v.price" class="price">
              {{ v.price ? '¥' + v.price : '' }}
            </p>
          </div>
        </div>
      </div>
      <el-pagination
        layout="prev, pager, next"
        :page-size="queryOrder.pageSize"
        @prev-click="prevClick"
        @next-click="nextClick"
        @current-change="currentChange"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { nftRecordList } from '../../request/api.js'
import { timeChange } from '../../assets/js/globle.js'
export default {
  props: {
    detail: {
      type: Object,
      default: function() {
        return {
          auditStatus: '',
          contractAddress: '',
          categoryName: '',
          isExchange: '',
          nftDesc: '',
          nftId: '',
          nftName: '',
          ownerId: '',
          picture: '',
          price: '',
          quantity: '',
          recommendType: '',
          reviewer: '',
          userId: '',
          userType: '',
          worksId: '',
          receipt: {},
          isCopy: 0,
          nftNumberVO: {}
        }
      }
    }
  },
  watch: {
    detail: {
      handler(val) {
        if (val) {
          this.historyInit()
        }
      },
      deeply: true
    }
  },
  data() {
    return {
      timeChange: timeChange,
      foldFlag: false,
      tableData: [],
      queryOrder: {
        pageNo: 1,
        pageSize: 10
      },
      totalCount: 0
    }
  },
  mounted() {},
  methods: {
    // 折叠
    foldOrUnfold() {
      let foldFlag = this.foldFlag
      this.foldFlag = !foldFlag
    },
    recordTypeChange(v) {
      // 事件类型（0：铸造，1：挂售，2：取消挂售，3：买入，4：转赠）
      let obj = {
        'type-0': '铸造',
        'type-1': '挂售',
        'type-2': '取消挂售',
        'type-3': '买入',
        'type-4': '转赠',
        'type-5': '买入',
        'type-6': '买入',
        'type-7': '抽中：' + v.nftName,
        'type-8': '发售',
        'type-9': '合成'
      }
      return obj['type-' + v.eventType]
    },
    prevClick(val) {
      this.queryOrder.pageNo = val
      this.historyInit()
    },
    nextClick(val) {
      this.queryOrder.pageNo = val
      this.historyInit()
    },
    currentChange(val) {
      this.queryOrder.pageNo = val
      this.historyInit()
    },
    historyInit() {
      let query = {
        nftId: this.detail.nftNumberVO.nftId,
        nftNo: this.detail.nftNumberVO.nftNo,
        pageNo: this.queryOrder.pageNo,
        pageSize: this.queryOrder.pageSize
      }
      nftRecordList(query).then(res => {
        this.tableData = res.data.records
        console.log(res.data.totalPage)
        this.totalCount = res.data.totalCount
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.history {
  // display: none;
  .title {
    // @extend .flex-between-center;
    p {
      color: #434343;
      font-size: 17px;
      font-weight: 500;
      margin: 33px 0 10px;
    }
    .el-icon-arrow-up,
    .el-icon-arrow-down {
      font-weight: bold;
      width: 23px;
      height: 11px;
      font-size: 20px;
      cursor: pointer;
      @media screen and(max-width:768px) {
        display: none;
      }
    }
  }
  .table {
    background: #fcfaf8;
    border-radius: 8px;
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    /deep/ .el-table {
      display: block;
      @media screen and(max-width:768px) {
        display: none;
      }
      border: 0;
      .cell {
        line-height: 44px;
      }
      th,
      tr {
        background-color: #fcfaf8;
        border: 0;
        height: 100px;
        color: #86765d;
        font-weight: normal;
        &:hover {
          td {
            background-color: #f8f2e8;
          }
        }
      }
      td {
        border: 0;
        height: 100px;
        color: #6b5736;
        font-size: 14px;
        border-top: 1px solid #efe3d6;
        .gift {
          padding: 10px 30px;
          color: #fff;
          font-size: 16px;
          line-height: 22px;
          background-color: #e8721d;
          border-radius: 21px;
          cursor: pointer;
        }
      }
      thead {
        color: #86765d;
        font-size: 15px;
      }
    }
    /deep/ .el-table--border::after,
    /deep/ .el-table--group::after {
      width: 0;
    }
    /deep/ .el-pagination {
      margin: 20px 0 20px 0;
      float: right;
      overflow: hidden;
      button:hover {
        color: #e8721d;
      }
    }
    /deep/ .el-pager li.active {
      color: #e8721d;
    }
    /deep/ .el-pager li:hover {
      color: #e8721d;
    }
    .table-phone {
      display: none;
      @media screen and(max-width:768px) {
        display: block;
        width: 100%;

        background-color: #fcfaf8;
        .item {
          width: 100%;
          height: 76px;
          border-bottom: 1px solid #eaeaea;
          .name {
            font-size: 13px;
            font-weight: 500;
            color: #434343;
            line-height: 18px;
          }
          .time {
            font-size: 13px;
            font-weight: 400;
            color: #ababab;
            line-height: 18px;
            margin: 10px 0 0 0;
          }
          .type {
            font-size: 13px;
            font-weight: 400;
            color: #434343;
            line-height: 18px;
          }
          .price {
            font-size: 13px;
            font-weight: 400;
            color: #434343;
            line-height: 18px;
            margin: 6px 0 0 0;
          }
        }
      }
    }
  }
  #table-fold {
    flex: auto;
    animation: fadeFold 0.5s forwards;
  }
  @keyframes fadeFold {
    0% {
      height: auto;
    }
    100% {
      height: 0;
    }
  }
  @keyframes fadeUnfold {
    0% {
      height: 0;
    }
    100% {
      height: auto;
    }
  }
  #table-unfold {
    flex: auto;
    animation: fadeUnfold 0.5s forwards;
  }
}
</style>



// WEBPACK FOOTER //
// src/conponents/history/index.vue